"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceAbilityHandler = exports.SliceActorAbilityFactory = exports.SliceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
class SliceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Slice;
        this.__typeName = "Slice";
    }
}
exports.SliceAbilityArgs = SliceAbilityArgs;
let SliceActorAbilityFactory = class SliceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Slice", "OneEnemies", 0);
    }
};
SliceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Slice")
], SliceActorAbilityFactory);
exports.SliceActorAbilityFactory = SliceActorAbilityFactory;
let SliceAbilityHandler = class SliceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 45)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10),
                    duration: Duration_1.Duration.Turns(3),
                    sequence
                });
            }
        });
    }
};
SliceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Slice)
], SliceAbilityHandler);
exports.SliceAbilityHandler = SliceAbilityHandler;
